// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DingtalkCircleFilledSvg from "@fishx/icons-svg/es/asn/DingtalkCircleFilled";
import FishxIcon from '../components/FishxIcon';

var DingtalkCircleFilled = function DingtalkCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DingtalkCircleFilledSvg
  }));
};

DingtalkCircleFilled.displayName = 'DingtalkCircleFilled';
export default React.forwardRef(DingtalkCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DingtalkCircleFilled.js
// module id = 2422
// module chunks = 0